import React from 'react';
import { Switch } from '@mui/material';
import { useTheme } from 'styles';

const OnOff = (props) => {
    const { label, input = {} } = props,
        { onChange, value } = input;

    const { Layout } = useTheme()

    return (
        <div style={{ ...Layout.rowHCenter }}>
            <div className='chanage-broken-value'>
                <Switch
                    checked={value ? true : false}
                    onChange={({ target }) =>
                        onChange(target.checked)
                    }
                    color="secondary" />
                {label}

            </div>
        </div>
    );
}

export default OnOff